import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders  } from "@angular/common/http";
import { map } from "rxjs/operators";

import { environment } from '../../environments/environment'
        

@Injectable()
export class BuzonService {
  constructor(public http: HttpClient) { }


  // enviarSolicitud(data: any) {
  //   // tslint:disable-next-line:prefer-const
  //   const url = environment.URL_QUEJATEL + "/solicitud";
  //   return this.http.post(url, data).pipe(map((resp: any) => {
  //     return resp;
  //   })
  //   );
  // }


  ///////////**** */
 

  enviarSolicitud(data: any) {


    var promise = new Promise((resolve, reject) => {

      const headers = { 'cmsquejatel2021': '66f59ca2b0571f7359e0ef0dc608ac4d' };
      const url = environment.URL_QUEJATEL + "/solicitud";

      const formData: FormData = new FormData();
      //formData.append("imagen", ficonstoUpload);
      formData.append("data", JSON.stringify(data));

      this.http.post<any>(url, data, { headers }).subscribe(data => {
        resolve(data)
      });


    })
    return promise;
  }


  // enviarArchivo(data: any, archivo: any) {
  //   // tslint:disable-next-line:prefer-const
  //   const url = environment.URL_QUEJATEL + "/solicitud_archivo";
  //   const formData: FormData = new FormData();
  //   formData.append("archivo", archivo);
  //   formData.append("data", JSON.stringify(data));
  //   return this.http.post(url, formData).pipe(map((resp: any) => {
  //     return resp;
  //   })
  //   );
  // }


  enviarArchivo(data: any, archivo: any) {


    var promise = new Promise((resolve, reject) => {

      const headers = { 'cmsquejatel2021': '66f59ca2b0571f7359e0ef0dc608ac4d' };
      const url = environment.URL_QUEJATEL + "/solicitud_archivo";

      const formData: FormData = new FormData();
      formData.append("archivo", archivo);
      formData.append("data", JSON.stringify(data));

      this.http.post<any>(url, formData, { headers }).subscribe(data => {
        resolve(data)
      });


    })
    return promise;
  }

  // getSolicitudPdf(id: any) {
  //   // tslint:disable-next-line:prefer-const
  //   const url = environment.URL_QUEJATEL + "/imprimir_solicitud/" + id;
  //   return this.http
  //     .get(url, { responseType: "blob" }).pipe(
  //       map((resp: any) => {
  //         const downloadUrl = window.URL.createObjectURL(resp);
  //         window.open(downloadUrl);
  //       })
  //     );
  // }


  getSolicitudPdf(id: any) {
    const url = environment.URL_QUEJATEL + "/imprimir_solicitud/" + id;
    var promise = new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("cmsquejatel2021", "66f59ca2b0571f7359e0ef0dc608ac4d");

      this.http
        .get(url, { responseType: "blob", headers }).subscribe((data: any) => {
          const downloadUrl = window.URL.createObjectURL(data);
          window.open(downloadUrl);
          
          })
    })
    return promise;
  }
  

  // getSolicitudesTipos() {
  //   const url = environment.URL_QUEJATEL + "/solicitudes_tipos";
  //   return this.http.get<any>(url).pipe(
  //     map((resp: any) => {
  //       return resp;
  //     })
  //   );
  // }


  getSolicitudesTipos() {
    const url = environment.URL_QUEJATEL + "/solicitudes_tipos";
    var promise = new Promise((resolve, reject) => {
      const headers = new HttpHeaders()
        .set("cmsquejatel2021", "66f59ca2b0571f7359e0ef0dc608ac4d");

      this.http
        .get( url, { headers }).subscribe((data: any) => {
            //     console.log(data)
            resolve(data.registros)
             console.log(data.registros)
          })
    })
    return promise;
  }

}
